import React from 'react';
import { motion } from 'framer-motion';

const education = [
  { title: "B.Sc. Computer Engineering", org: "University of Lagos" },
  { title: "CPISM (Certificate of Proficiency in Information Systems Management)", org: "Kani Africa" },
];

const languages = "English (fluent) · Arabic (conversational)";

const Education = () => {
  return (
    <div className="py-4" id="education">
      <div className="container2">
        <div className="sec-header mb-4 text-center">
          <h2 className="text-bold">Education & Certification</h2>
          <p className="about-text text-muted">Background</p>
        </div>
        <motion.div
          className="edu-list"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          {education.map((item) => (
            <div className="edu-item" key={item.title}>
              <p className="fw-bold m-0">{item.title}</p>
              <small className="text-muted">{item.org}</small>
            </div>
          ))}
          <div className="text-center pt-2">
            <small className="text-muted">{languages}</small>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Education;
